import { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Jumbotron, Row } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import ChargeManagementEditViewModel from "viewModels/chargeManagement/chargeManagementEdit/chargeManagementEditViewModel";
import AlertWithInfoIcon from "views/common/alertWithInfoIcon/alertWithInfoIcon";
import classNames from "classnames";
import Tooltip from "controls/tooltip";
import { getTimeZoneLabel } from "utils/dateUtils";
import { isMobile } from "react-device-detect";

const ChargeInfo: ViewComponent<ChargeManagementEditViewModel> = observer(({ vm }) => {
  const renderDateWithTimeZone = (date: Date) => {
    const formatted = vm.localizationService.formatDateTime(date);
    return !vm.isDifferentTimeZone ? (
      <span>{formatted}</span>
    ) : (
      <>
        <span>{formatted}</span>
        <Tooltip
          id="cet-tooltip"
          placement={isMobile ? "bottom" : "right"}
          tooltip={vm.localizationService.translateGeneral("timezoneTooltip")}
          trigger={["hover", "focus"]}>
          <span style={{ marginLeft: 4, textDecoration: "underline", textDecorationStyle: "dotted" }}>
            {getTimeZoneLabel(date)}
          </span>
        </Tooltip>
      </>
    );
  };

  return (
    <Jumbotron className="bg-light pt-5 pb-3">
      <Row className="d-flex align-items-top justify-content-between">
        <Col xs={12} md={4} className="mb-3">
          <h6 className="mb-1">{vm.translate("countryOfRegistration")}</h6>
          <span>{vm.registrationCountry}</span>
        </Col>
        <Col xs={12} md={4} className="mb-3">
          <h6 className="mb-1">{vm.translate("licensePlateLabel")}</h6>
          <span>{vm.licensePlate}</span>
        </Col>
        <Col xs={12} md={4} className="mb-3">
          <h6 className="mb-1">{vm.translate("typeOfStamp")}</h6>
          <span>{vm.chargeTypeWithPrice}</span>
        </Col>
        <Col xs={12} md={4} className="mb-3">
          <h6 className="mb-1">{vm.translate("drive")}</h6>
          <span>{vm.drive}</span>
        </Col>
        <Col xs={12} md={4} className="mb-3">
          <h6 className="mb-1">{vm.translate("validFrom")}</h6>
          <span className={classNames(vm.isRefunded && "invalidated")}>
            {vm.validSince !== "-" ? renderDateWithTimeZone(new Date(vm.validSince)) : "-"}
          </span>
        </Col>
        <Col xs={12} md={4} className="mb-3">
          <h6 className="mb-1">{vm.translate("validTo")}</h6>
          <span className={classNames(vm.isRefunded && "invalidated")}>
            {vm.validUntil !== "-" ? renderDateWithTimeZone(new Date(vm.validUntil)) : "-"}
          </span>
        </Col>
      </Row>
      {vm.newChargePurchaseUrl && (
        <AlertWithInfoIcon variant="warning" className="mt-4">
          <ReactMarkdown linkTarget="_blank">
            {vm.translate("nextChargePurchase").replace("%link%", vm.newChargePurchaseUrl)}
          </ReactMarkdown>
        </AlertWithInfoIcon>
      )}
    </Jumbotron>
  );
});

export default ChargeInfo;
